import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => {
  return {
    unitsModelsManangementSideMnue: {
      width: "688px",
      height: "100vh",
      position: "fixed",
      top: 0,
      right: 0,
      backgroundColor: "#fff",
      boxShadow: theme.shadows[5],
      transform: "translateX(0)",
      transition: "transform 0.3s ease-in-out",
      zIndex: 1300,
      display: "flex",
      flexDirection: "column",
      overflowY: "auto",
      boxSizing: "border-box",
      [theme.breakpoints.down("sm")]: {
        width: "100vw",
      },
    },
    hidden: {
      transform: "translateX(100%)",
    },
    header: {
      padding: "24px 24px 0px 24px",
      display: "flex",
      flexDirection: "column",
      background: theme.palette.background.paper,
    },
    containerTitlePlusBackIcon: {
      display: "flex",
      flexDirection: "row",
      justifyContent: "space-between",
    },
    mainTitle: {
      fontSize: "18px",
      fontWeight: 600,
      color: theme.palette.text.primary,
      lineHeight: "28px",
    },
    subTitle: {
      fontSize: "14px",
      fontWeight: 400,
      color: theme.palette.text.tertiary,
      lineHeight: "20px",
    },
    wrapperContentSideMenu: {
      padding: "20px 24px",
      background: theme.palette.background.paper
    },
    containerInputSection: {
      display: "flex",
      flexDirection: "row",
      gap: "16px 32px",
      [theme.breakpoints.down("xs")]: {
        flexDirection: "column",
      },
    },
    titleFiled: {
      fontSize: "14px",
      fontWeight: 500,
      lineHeight: "24px",
      color: theme.palette.text.secondary,
      maxWidth: "280px",
      minWidth: "160px",
    },
    containerUpladedFilesCrads: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      width: "100%",
    },
    CardUploadedFilesInfo: {
      display: "flex",
      flexDirection: "row",
      padding: "16px",
      gap: "12px",
    },
    ContainerFileUploadedInfo: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
    },
    containerTitleAndDeleteIcon: {
      position: "relative",
    },
    DeleteIcon: {
      cursor: "pointer",
      position: "absolute",
      right: "0px",
      top: "0px",
    },
    footerActions: {
      display: "flex",
      gap: "12px",
      alignItems: "center",
      justifyContent: "flex-end",
      paddingTop: "24px",
      [theme.breakpoints.down("sm")]: {
        marginBottom: "80px",
      },
    },
    containerFormAddUnitModel: {
      display: "flex",
      flexDirection: "column",
      gap: "16px",
      maxWidth: "100%",
    },
    containerCustomInput: { maxWidth: "100%" },
  };
});
